import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OAuthErrorPage } from '@/pages/oauth/OAuthErrorPage';

export const Route = createFileRoute('/oauth/error')({
	validateSearch: z.object({
		error: z.string().optional(),
		error_description: z.string().optional(),
	}),
	component: OAuthErrorPage,
});
